import { Routes, RouterModule } from '@angular/router';

const ROUTES: Routes = [
    { path: '', loadChildren: './layout/layout.module#LayoutModule' }
];

export const routing = RouterModule.forRoot(ROUTES);


// WEBPACK FOOTER //
// C:/Users/gfurtado/Projects/v2.3 (ng4 2.1 only)/Angular 4 CLI/app/src/app/app.routing.ts